import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';
import { CertificadoRecebiveisApiResponse } from 'common/genericTypes';
import {
  tipoSerieDescriptions,
  negociacaoSecundariaDescriptions,
  depositariaEmissaoDescriptions,
  tipoLiquidacaoDescriptions,
  contraparteRecebedoraDescriptions,
} from 'common/genericDescriptions';
import moment from 'moment';
import { addCpfCnpjMask } from 'utils/mask';
import { formatCurrencyNumber } from 'utils/number';

interface Props {
  certificadoRecebiveis: CertificadoRecebiveisApiResponse;
}

export const DetalhesCaracteristicas: React.FC<Props> = ({ certificadoRecebiveis }) => (
  <>
    <Section title={'Características da Emissão'} defaultGrid>
      <div>
        <Typography variant="body2">{'Número da Emissão:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.numeroEmissao}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Número da série:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.numeroSerie}</Typography>
        <SmSpace />
      </div>
      {certificadoRecebiveis.tipoSerie && (
        <div>
          <Typography variant="body2">{'Tipo de série:'}</Typography>
          <Typography variant="body1">{tipoSerieDescriptions[certificadoRecebiveis.tipoSerie]}</Typography>
          <SmSpace />
        </div>
      )}
      <div>
        <Typography variant="body2">{'Possui Vasos Comunicantes:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.vasosComunicantes ? 'Sim' : 'Não'}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Regime Fiduciário:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.regimeFiduciario ? 'Sim' : 'Não'}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Distribuição Pública:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.distribuicaoPublica ? 'Sim' : 'Não'}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Negociação Secundária por:'}</Typography>
        <Typography variant="body1">
          {negociacaoSecundariaDescriptions[certificadoRecebiveis.negociacaoSecundariaPor]}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Termo Securit. Formalizado:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.termoSecuritizacaoFormalizado ? 'Sim' : 'Não'}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Depositária Emissão:'}</Typography>
        <Typography variant="body1">
          {depositariaEmissaoDescriptions[certificadoRecebiveis.depositariaEmissao]}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Código CVM:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.codigoCvmCiaSecuritizadora}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Anúncio de Início de Distribuição:'}</Typography>
        <Typography variant="body1">
          {certificadoRecebiveis.utilizacaoAnuncioInicioDistribuicao ? 'Sim' : 'Não'}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'UF da Emissão:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.ufLocalEmissao}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Município de Emissão:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.localEmissao}</Typography>
        <SmSpace />
      </div>
      {certificadoRecebiveis.classificadoraRisco1 && (
        <div>
          <Typography variant="body2">{'Classificadora de Risco 1:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.classificadoraRisco1}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.classificadoraRisco2 && (
        <div>
          <Typography variant="body2">{'Classificadora de Risco 2:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.classificadoraRisco2}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.rating1 && (
        <div>
          <Typography variant="body2">{'Rating 1:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.rating1}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.rating2 && (
        <div>
          <Typography variant="body2">{'Rating 2:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.rating2}</Typography>
          <SmSpace />
        </div>
      )}
      <div>
        <Typography variant="body2">{'UF do Pagamento:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.ufLocalPagamento}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Município do Pagamento:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.localPagamento}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Nome Resp. Infos. (DRI):'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.nomeResponsavelPelasInformacoesDRI}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'E-mail Resp. Infos. (DRI):'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.emailResponsavelPelasInformacoesDRI}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Tipo de Liquidação:'}</Typography>
        <Typography variant="body1">{tipoLiquidacaoDescriptions[certificadoRecebiveis.tipoLiquidacao]}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Banco Liquidante do Emissor:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.bancoLiquidanteEmissor}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'CNPJ Banco Liquid. Emissor:'}</Typography>
        <Typography variant="body1">{addCpfCnpjMask(certificadoRecebiveis.cnpjBancoLiquidanteEmissor)}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Cód. Banco Vinculado à Emissão:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.codigoBancoContaCorrenteVinculadaEmissao}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Ag. Vinculada à Emissão:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.numeroAgenciaContaCorrenteVinculadaEmissao}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Nº CC. Vinculada à Emissão:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.numeroContaCorrenteVinculadaEmissao}</Typography>
        <SmSpace />
      </div>
      {certificadoRecebiveis.chaveExterna && (
        <div>
          <Typography variant="body2">{'Chave Externa:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.chaveExterna}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.isin && (
        <div>
          <Typography variant="body2">{'Código ISIN:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.isin}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.razaoSocialEscriturador && !certificadoRecebiveis.distribuicaoPublica && (
        <div>
          <Typography variant="body2">{'Razão Social Escriturador:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.razaoSocialEscriturador}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.cnpjEscriturador && !certificadoRecebiveis.distribuicaoPublica && (
        <div>
          <Typography variant="body2">{'CNPJ Escriturador:'}</Typography>
          <Typography variant="body1">{addCpfCnpjMask(certificadoRecebiveis.cnpjEscriturador)}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.descricaoAdicional && (
        <div>
          <Typography variant="body2">{'Descrição Adicional:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.descricaoAdicional}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.codigoExterno && (
        <div>
          <Typography variant="body2">{'Código Externo:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.codigoExterno}</Typography>
          <SmSpace />
        </div>
      )}
    </Section>
    {certificadoRecebiveis.distribuicaoPublica && (
      <Section title={'Distribuição Pública'}>
        <Grid container spacing={5} style={{ width: '100%' }}>
          <Grid item md={6}>
            {certificadoRecebiveis.tipoDistribuicaoPublica && (
              <div>
                <Typography variant="body2">{'Tipo de Distribuição Pública:'}</Typography>
                <Typography variant="body1">{certificadoRecebiveis.tipoDistribuicaoPublica}</Typography>
                <SmSpace />
              </div>
            )}
          </Grid>
          <Grid item md={6}>
            {certificadoRecebiveis.dataEncerramentoDistribuicao && (
              <div>
                <Typography variant="body2">{'Data de Encerramento da Distribuição:'}</Typography>
                <Typography variant="body1">
                  {moment(certificadoRecebiveis.dataEncerramentoDistribuicao).format('DD/MM/YYYY')}
                </Typography>
                <SmSpace />
              </div>
            )}
          </Grid>
          <Grid item md={6}>
            {certificadoRecebiveis.contraparteRecebedora && (
              <div>
                <Typography variant="body2">{'Contraparte Recebedora:'}</Typography>
                <Typography variant="body1">{contraparteRecebedoraDescriptions[certificadoRecebiveis.contraparteRecebedora]}</Typography>
                <SmSpace />
              </div>
            )}
          </Grid>
          <Grid item md={12}>
            {certificadoRecebiveis.coordenadores?.length > 0 && (
              <div>
                <Typography variant="body2">{'Coordenadores:'}</Typography>
                <Typography variant="body1">
                  {certificadoRecebiveis.coordenadores.map((c) => c.razaoSocial).join(', ')}
                </Typography>
                <SmSpace />
              </div>
            )}
          </Grid>
          {certificadoRecebiveis.coordenadorLider && (
            <>
              <Grid item md={6}>
                <div>
                  <Typography variant="body2">{'Razão Social Coord. Líder:'}</Typography>
                  <Typography variant="body1">{certificadoRecebiveis.coordenadorLider.razaoSocial}</Typography>
                  <SmSpace />
                </div>
              </Grid>
              <Grid item md={6}>
                <div>
                  <Typography variant="body2">{'CNPJ Coord. Líder:'}</Typography>
                  <Typography variant="body1">{addCpfCnpjMask(certificadoRecebiveis.coordenadorLider.cnpj)}</Typography>
                  <SmSpace />
                </div>
              </Grid>
            </>
          )}
          <Grid item md={6}>
            {certificadoRecebiveis.razaoSocialEscriturador && (
              <div>
                <Typography variant="body2">{'Razão Social Escriturador:'}</Typography>
                <Typography variant="body1">{certificadoRecebiveis.razaoSocialEscriturador}</Typography>
                <SmSpace />
              </div>
            )}
          </Grid>
          <Grid item md={6}>
            {certificadoRecebiveis.cnpjEscriturador && (
              <div>
                <Typography variant="body2">{'CNPJ Escriturador:'}</Typography>
                <Typography variant="body1">{addCpfCnpjMask(certificadoRecebiveis.cnpjEscriturador)}</Typography>
                <SmSpace />
              </div>
            )}
          </Grid>
        </Grid>
      </Section>
    )}
    {!(certificadoRecebiveis.custodiantes?.length === 0) && (
      <Section title={'Custodiantes'} defaultGrid>
        {certificadoRecebiveis.custodiantes?.map((custodiante) => {
          let razaoCustodiante = custodiante.razaoSocialInstituicaoCustodiante;
          let cnpjCustodiante = custodiante.cnpjInstituicaoCustodiante;
          return (
            <>
              <div>
                <Typography variant="body2">{'Razão Social Inst. Custodiante:'}</Typography>
                <Typography variant="body1">{razaoCustodiante}</Typography>
                <SmSpace />
              </div>
              <div>
                <Typography variant="body2">{'CNPJ Inst. Custodiante:'}</Typography>
                <Typography variant="body1">{addCpfCnpjMask(cnpjCustodiante)}</Typography>
                <SmSpace />
              </div>
            </>
          )
        })
        }
      </Section>
    )}
    <Section title={'Informações do Lastro'} defaultGrid>
      <div>
        <Typography variant="body2">{'Averbado em cartório:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.averbadoEmCartorio ? 'Sim' : 'Não'}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Registro na Inst. Custodiante:'}</Typography>
        <Typography variant="body1">
          {certificadoRecebiveis.registroNaInstituicaoCustodiante ? 'Sim' : 'Não'}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Garantia Flutuante:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.garantiaFlutuante ? 'Sim' : 'Não'}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Tipo de Garantia:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.tipoGarantia}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Ativo da Garantia:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.ativoGarantia}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Nome do Garantidor:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.nomeGarantidor}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'CPF/CNPJ do Garantidor:'}</Typography>
        <Typography variant="body1">{addCpfCnpjMask(certificadoRecebiveis.cpfCnpjGarantidor ?? '')}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Natureza do Garantidor:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.naturezaGarantidor}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Valor da Garantia:'}</Typography>
        <Typography variant="body1">{formatCurrencyNumber(certificadoRecebiveis.valorGarantia)}</Typography>
        <SmSpace />
      </div>
    </Section>
    {certificadoRecebiveis.regimeFiduciario && (
      <Section title={'Regime Fiduciário'} defaultGrid>
        {certificadoRecebiveis.coobrigacao && (
          <div>
            <Typography variant="body2">{'Coobrigação:'}</Typography>
            <Typography variant="body1">{certificadoRecebiveis.coobrigacao ? 'Sim' : 'Não'}</Typography>
            <SmSpace />
          </div>
        )}
        {certificadoRecebiveis.naturezaAgenteFiduciario && (
          <div>
            <Typography variant="body2">{'Natureza Agente Fiduciário:'}</Typography>
            <Typography variant="body1">{certificadoRecebiveis.naturezaAgenteFiduciario}</Typography>
            <SmSpace />
          </div>
        )}
        {certificadoRecebiveis.razaoSocialAgenteFiduciario && (
          <div>
            <Typography variant="body2">{'Razão Social Agente Fiduciário:'}</Typography>
            <Typography variant="body1">{certificadoRecebiveis.razaoSocialAgenteFiduciario}</Typography>
            <SmSpace />
          </div>
        )}
        {certificadoRecebiveis.cpfCnpjAgenteFiduciario && (
          <div>
            <Typography variant="body2">{'CNPJ Agente Fiduciário:'}</Typography>
            <Typography variant="body1">{addCpfCnpjMask(certificadoRecebiveis.cpfCnpjAgenteFiduciario)}</Typography>
            <SmSpace />
          </div>
        )}
      </Section>
    )}
  </>
);
